import React, { Component } from 'react';
//import './index.css';
import App from './App';
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import reducers from "./store/reducer/index";
import { createStore, applyMiddleware } from "redux";

class Sale extends Component {
  constructor(props) {
    super(props);
    this.store = createStore(reducers, applyMiddleware(thunk));
  }
  render() {
    return (
      <Provider store={this.store}>
        <App />
      </Provider>)
  };
}

export default Sale;
